import {QuantityPicker} from '../../../shopify-product-info/components/quantity-picker/quantity-picker';
import {Product} from '../../../../interfaces/product.interface';
import {ShopifyService} from '../../../../api/services/shopify.service';
import {IdealCartService} from '../../../../api/services/ideal-cart.service';
import {IdealVariant} from '../../../../interfaces/shopify-product.interface';
import {IdealService} from '../../../../api/services/ideal.service';

export class IdealQuantityPicker extends QuantityPicker {
  constructor(
    readonly product: Product,
    readonly mainContainer: HTMLElement,
    readonly shopifyService: ShopifyService | IdealService,
    readonly shoppingCartService: IdealCartService
  ) {
    super(product, mainContainer, shopifyService, shoppingCartService);
  }

  get product_quantity() {
    return this.quantity;
  }

  get product_variant_id() {
    return (this.variant as IdealVariant)?.sku;
  }

  get per_order_limit() {
    return undefined;
  }

  get product_variant_inventory_quantity() {
    return this.variant?.inventory_quantity;
  }

  updateAvailableQuantity() {
    this.availableQuantity = this.variant?.quantity;
  }
}
